module.exports = __webpack_public_path__ + "static/img/pic-line2.460797ba.png";